import { Input } from 'antd';
import { debounce } from 'lodash';

import { useCourseStudentsStats } from '@/store';

export const StudentsSearch = () => {
  const { setSearch, isLoading } = useCourseStudentsStats();
  const resetSearch = () => setSearch('');

  const handleStudentSearch = async (value: string) => {
    if (value === '') resetSearch();
    if (value.length < 2) {
      return;
    }
    setSearch(value);
  };

  const handleSearch = debounce(handleStudentSearch, 500);
  return (
    <Input.Search loading={isLoading} allowClear onChange={e => handleSearch(e.target.value)} />
  );
};
